import { supabase } from '../supabase';
import { RecommendationFilters } from '../types';

/**
 * Serviço para construir filtros de recomendação com base no perfil do usuário
 */
export class RecommendationFilterBuilder {
  /**
   * Constrói filtros com base no perfil do usuário
   */
  public async buildFiltersFromUserProfile(userId: string): Promise<RecommendationFilters> {
    try {
      // Buscar preferências do usuário
      const { data: preferences, error: preferencesError } = await supabase
        .from('user_preferences')
        .select('*')
        .eq('user_id', userId)
        .single();
        
      if (preferencesError) {
        console.log('Preferências do usuário não encontradas, usando filtros padrão');
        return this.getDefaultFilters();
      }
      
      const filters: RecommendationFilters = {};
      
      // Categorias favoritas
      if (preferences.favorite_categories && Array.isArray(preferences.favorite_categories)) {
        filters.categories = preferences.favorite_categories;
      }
      
      // Número de jogadores
      if (preferences.preferred_player_count) {
        // Definir um range em torno do número preferido
        filters.minPlayers = Math.max(1, preferences.preferred_player_count - 1);
        filters.maxPlayers = preferences.preferred_player_count + 2;
      }
      
      // Tempo de jogo
      if (preferences.max_play_time) {
        filters.maxPlayTime = preferences.max_play_time;
      }
      
      // Complexidade
      if (preferences.preferred_complexity !== undefined) {
        // Range de complexidade em torno do valor preferido
        const complexityRange = 1.0;
        filters.minComplexity = Math.max(1, preferences.preferred_complexity - complexityRange);
        filters.maxComplexity = Math.min(5, preferences.preferred_complexity + complexityRange);
      }
      
      return filters;
    } catch (error) {
      console.error('Erro ao construir filtros:', error);
      return this.getDefaultFilters();
    }
  }
  
  /**
   * Retorna filtros padrão quando não há preferências do usuário
   */
  private getDefaultFilters(): RecommendationFilters {
    return {
      // Filtros padrão muito abrangentes
      minComplexity: 1,
      maxComplexity: 5,
      minPlayers: 1,
      maxPlayers: 8,
      maxPlayTime: 180
    };
  }
} 